import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import calendar from './calendar';

const initialState = {
  workspaces: [],
  currWorkspaceIndex: 0,
  isSidebarOpened: true,
  openModal: null,
  patientsSearched: [],
  isOnDuty: false,
  loadingDuty: false,
};

const dashboardModule = {
  namespaced: true,

  state: initialState,
  mutations,
  actions,
  getters,
  modules: {
    calendar,
  },
};

export default dashboardModule;
